import { NavigationItem } from '../../../data/types';
import { mapTags } from '../../../utils/tag-creators';
import * as s from './Navigation.scss';

export interface SubSubMenuItemProps {
  item: NavigationItem;
  t(key: string): string;
  language: string;
}

export const ArrowRight = () => {
  return `<span class="${s.arrowRight}">→</span>`;
};

export const SubSubMenuItem = ({ item, t, language }: SubSubMenuItemProps) => {
  return `
    <li class="${s.subSubMenuItem}">
      <div class="${s.linkWrapper}">
        <a
          class="${s.link}"
          href="${item.href}"
          target="${item.target || ''}"
          data-bi-name="${item.name}"
          data-bi-row="third"
          ${language === 'en' ? 'role="menuitem"' : ''}
        >
          ${t(item.text)}
          ${item.subs?.length ? ArrowRight() : ''}
        </a>
        <div class="${s.description}">${t(item.description || '')}</div>
      </div>
    </li>
  `;
};

export interface SubSubMenuProps {
  labelledBy: string;
  items: NavigationItem[];
  t(key: string): string;
  language: string;
}

export const SubSubMenu = ({ labelledBy, items, t, language }: SubSubMenuProps) => {
  if (!items.length) {
    return '';
  }
  return `
    <div
      class="${s.subSubMenuContainer} items-${items.length}"
      role="region"
      aria-labelledby="${labelledBy}"
    >
      <ul
        class="${s.subSubMenu}"
        ${language === 'en' ? 'role="menu"' : ''}
      >
        ${mapTags(items, (item) => SubSubMenuItem({ item, t, language }))}
      </ul>
    </div>
    <div class="${s.subMenuSeparator}"></div>
  `;
};
